import { VideoRecordService } from './VideoRecordService'
export const videoRecordService = new VideoRecordService()
